module.exports = {
      id: "photo-usage",
      viewBox: "0 0 12 9",
      url: "/" + "sprite-036dd45d0e77a995aefc8cbeaab2becc.svg#photo",
      toString: function () {
        return this.url;
      }
    }